export const IAuthorizerKey = Symbol('IAuthorizer');

export interface IAuthorizer {
  isLoggedIn(): boolean;

  getIdToken(): Promise<string | null>;
}
